import React, { useState } from "react";

import { HeaderBar } from "../../components";
import { ScreenSelector } from "./ScreenSelector";

import {KeyValue} from "../../types";

import * as s from "./styles.module.css"

const headerBarItems: Array<KeyValue> = [
  { key: 'apresentacao', value: "Apresentação" },  
  { key: 'eficiencia-produtiva', value: "Eficiência Produtiva" },
  { key: 'modulo-avancado', value: "Módulo Avançado" },
  { key: 'avaliacao-genetica', value: "Avaliação Genética" },
  { key: 'acasalamentos', value: "Acasalamentos" },
  { key: 'csg', value: "CSG" },
  { key: 'pnat', value: "PNAT" },
  { key: 'tendencia-geneticas', value: "Tendências Genéticas e Endogamias" },
]

export default function EficienciaReprodutiva() {
  const [selectedPage, setSelectedPage] = useState<string> ("apresentacao")
  
  const handleLink = (value: string) => {
    setSelectedPage(value)
  };

  return (
    <div className={s.eficienciaReprodutiva}>
      <HeaderBar active={selectedPage} onClick={handleLink} items={headerBarItems} />
      <ScreenSelector page={selectedPage}/>
    </div>
  );
}
